import orderBy from 'lodash/orderBy'

export const orderByPositionAsc = (elements) =>
  orderBy(Object.values(elements), ['position'], ['asc'])
